import { Component } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { DataLayerBaseComponent } from './data-layer-base.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';

declare var L;
declare var require: any;
const omnivore = require('../../node_modules/leaflet-omnivore/leaflet-omnivore.min.js');

/*
 * data-layer-kml-point defines a class to display kml.
 *
 * Within the configuration file, kml point data can be included:
 * "overlayLayers": [
 * 		{"id": "kmlLayer", "label": "Weather Watches/Alerts", "url": "map/overlay-layers/poly.kml",
 *		 "class": "data-layer-kml-point", "refresh": false },
 * ...
 * ]
 */

@Component({
	selector: 'data-layer-kml-point',
	template: `
		<div class="checkboxDiv"><label class="overlay-layer"><input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
		<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>
		`,
	styleUrls: ['app.component.css']
})
export class DataLayerKmlPointComponent extends DataLayerBaseComponent {
	http: HttpClient;

	constructor(
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		userMessageService: UserMessageService,
		http: HttpClient) {
		super(mapService, dataLayerService, configService, userMessageService);
		this.http = http;
	}

	menuControlSelected (event): void {
		if ( event.target.checked ) {
			this.activateLayer();
		} else {
			this.deactivateLayer();
		}

	}

	// refreshLayer first checks to see if the layer is active.  If so, activateLayer is called.
	refreshLayer() {
		if ( this.active === true ) {
			this.activateLayer();
		}
	}

	// first check whether the information has been read.
	// display the markers on the map and set the layer to active
	activateLayer () {
		console.log('Activating ' + this.id + ' layer.');
		if ( this.mapLayer != null ) {
			this.mapService.map.removeLayer(this.mapLayer);
		}
		if ( this.value == null || this.refresh === true ) {
			// once the data file has been read, drawMarkers is automatically called because an observer has been established
			this.parseDataFile();
		}
		// console.log(this);
		const kmlLayer = L.geoJson(null, {
			// http://leafletjs.com/reference.html#geojson-style
			pointToLayer: this.placeMarkers,
			onEachFeature: this.onEachPointFeature,
			style: function (feature) {
				// console.log(feature);
				return { color: feature.properties.stroke, weight: feature.properties['stroke-width'], opacity: feature.properties['stroke-opacity'] };
			},
			contents: this
		}, this);

		this.http.get(this.value, {responseType: 'text' } )
			.subscribe ((data) => {
				console.log(data);
				this.mapLayer = omnivore.kml.parse( data, null, kmlLayer )
					.addTo(this.mapService.map).bringToFront();

				console.log(this.mapLayer);
			});


		/****************************
		// this worked for reading a kml layer
		var radarFileName2 = this.baseDir + "map/overlay-layers/poly.kml";
		omnivore.kml( radarFileName2 )
			.addTo(this.map).bringToFront();

		var tmp2 = omnivore.kml(radarFileName2);
		console.log(tmp2);
		******************/
		/****************************
		// this worked for displaying a web map service product
		var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
			layers: 'nexrad-n0r-900913',
			format: 'image/png',
			transparent: true,
			attribution: "Weather data © 2012 IEM Nexrad"
		});
		nexrad.addTo(this.map).bringToFront();
		******************/

		this.active = true;

	}

	drawMarkers () {
		console.log('Drawing ' + this.value.features.length + ' stations.');
		this.mapLayer = L.geoJson(this.value, {
			// placeMarkers using configuration which specifies which property should be used as the title, popup, etc.
			pointToLayer: this.placeMarkers,
			onEachFeature: this.onEachPointFeature
		}, this).addTo(this.mapService.map);
	}

	// extended classes should implement this function
	onEachPointFeature(feature, layer) {
		console.log('In onEachPointFeature', feature);

		let popupContent = '<pre>' + feature.properties.description + '</pre>';
		const options = { maxHeight: 500, minWidth: 500 };
		const tooltipContent = 'Click for detailed information';

		if (feature.properties && feature.properties.popupContent) {
			// This will append content from a "popupContent" property if it is in the GeoJSON file
			popupContent += feature.properties.popupContent;
		}

		layer.bindPopup(popupContent, options);
		layer.bindTooltip(tooltipContent);
	}

	// extended classes should implement this function
	placeMarkers(feature, latlng) {
		const marker = L.ExtraMarkers.icon({
				icon: 'fa-number',
				markerColor: 'yellow',			// marker background color
				shape: 'square',
				prefix: 'fa',
				number: ''
			});
		marker.options.shadowSize = [50, 75];
		// marker.options.title = "hello";
		return L.marker(latlng, {icon: marker});
	}

	deactivateLayer() {
		console.log('Deactivating ' + this.id + ' layer.');
		if ( this.active === true ) {
			this.mapService.map.removeLayer(this.mapLayer);
			this.active = false;
		}

	}

	parseDataFile () {
		console.log('In data-layer-kml-point.parseDataFile.');
		const kmlUrl = this.configService.baseDir + this.url + '?nocache=' + (new Date()).getTime();
		this.value = kmlUrl;
		console.log('Using ' + kmlUrl + ' for all ' + this.htmlElementLabel + '.');
	}

}
